export default function ReportAnalytics() {
  return (
    <div className="flex h-full flex-col">
      <section className="relative flex grow flex-col">
        <h1>Patient count</h1>
      </section>
    </div>
  );
}
